import { dateEnd, dateStart, dateTimeAdd } from "utils/dateUtils";

export const placeTypes = [
    { value: "none", label: "None" },
    { value: "virtual", label: "Virtual" },
    { value: "physical", label: "Physical" },
];

export const eventColors = [
    { value: "#D50000", label: "Tomato" },
    { value: "#E67C73", label: "Flamingo" },
    { value: "#F4511E", label: "Tangerine" },
    { value: "#F6BF26", label: "Banana" },
    { value: "#33B679", label: "Sage" },
    { value: "#0B8043", label: "Basil" },
    { value: "#039BE5", label: "Peacock", default: true },
    { value: "#3F51B5", label: "Blueberry" },
    { value: "#7986CB", label: "Lavender" },
    { value: "#8E24AA", label: "Grape" },
    { value: "#616161", label: "Graphite" },
];

export const colorOpacities = ["c4", "8f"];

export const getDefaultEventColor = () => eventColors.find((x) => x.default).value;

export const eventPermissions = [
    {
        value: "guestPermissionsModify",
        label: "Modify",
    },
    {
        value: "guestPermissionsInviteOthers",
        label: "Invite others",
    },
    {
        value: "guestPermissionsSeeGuestList",
        label: "See guest list",
    },
];

// Strongly dependent of the moment library 
export const calculateRange = (view, date, exact = false) => {
    switch (view) {
        case "day":
            return {
                start: dateStart(date, "day").toDate(),
                end: dateEnd(date, "day").toDate(),
            };
        case "week":
            return {
                start: dateStart(date, "week").toDate(),
                end: dateEnd(date, "week").toDate(),
            };
        case "month":
            const dateFrom = dateStart(date, "month");
            const dateTo = dateEnd(date, "month");
            return {
                start: exact ? dateFrom.toDate() : dateFrom.subtract(7, "days").toDate(),
                end: exact ? dateTo.toDate() : dateTo.add(7, "days").toDate(),
            };
        case "agenda":
            const dateFrom_agenda = dateStart(date, "day");
            const dateTo_agenda = dateTimeAdd(date, 1, "month").endOf("day");
            return {
                start: dateFrom_agenda.toDate(),
                end: dateTo_agenda.toDate(),
            };

        default:
            return null;
    }
};

export const buildSetGoingSuccessMessage = (answer, note) => {
    const withNoteMessage = note ? "Your note was sent!" : "";
    switch (answer) {
        case true:
            return `You are going to this event. ${withNoteMessage}`;
        case false:
            return `You are not going to this event. ${withNoteMessage}`;
        case null:
            return `You are probably going to this event. ${withNoteMessage}`;
        default:
            return "Answer saved!";
    }
};
